// extracted by mini-css-extract-plugin
export default {"userAccount":"PartnerPanelPage_userAccount__j8JAA","hr":"PartnerPanelPage_hr__PoMX+","gameSelector":"PartnerPanelPage_gameSelector__EkyTJ"};